import { Link } from 'react-router-dom';
import {
  BellIcon,
  DocumentTextIcon,
  ChatBubbleLeftRightIcon,
  PaperAirplaneIcon,
  TicketIcon,
} from '@heroicons/react/24/outline';
import { PageHeader } from '@/components/layout';
import { Card } from '@/components/common';

const modules = [
  {
    name: 'Notifications',
    description: 'View and send notifications to users',
    href: '/notifications',
    icon: BellIcon,
    color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
  },
  {
    name: 'Templates',
    description: 'Manage notification templates',
    href: '/templates',
    icon: DocumentTextIcon,
    color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
  },
  {
    name: 'Support Tickets',
    description: 'Customer support ticket management',
    href: '/tickets',
    icon: TicketIcon,
    color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
  },
  {
    // Board #232. This card pointed at /tickets -- the same destination as the
    // card above it, so "Chat" opened the ticket inbox and the chat surface was
    // unreachable from anywhere in the app.
    name: 'Chat',
    description: 'Conversations by channel',
    href: '/chat',
    icon: ChatBubbleLeftRightIcon,
    color: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
  },
  {
    name: 'Gateways',
    description: 'Email, SMS and WhatsApp providers',
    href: '/settings/gateways',
    icon: PaperAirplaneIcon,
    color: 'bg-teal-100 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400',
  },
];

export function CommunicationsPage() {
  return (
    <div>
      <PageHeader
        title="Communications"
        subtitle="Manage all communication channels"
        breadcrumbs={[{ label: 'Communications' }]}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {modules.map((module) => (
          <Link key={module.name} to={module.href}>
            <Card className="hover:shadow-md transition-shadow cursor-pointer h-full">
              <div className={`p-3 rounded-lg w-fit ${module.color}`}>
                <module.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mt-4">{module.name}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{module.description}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
